/** Board back navigation returns to its list, not the previous editor tab. */
export function boardBackTarget(pathname: string): string | null {
  const triggerPool = pathname.match(
    /^\/agent-builder\/triggers\/([^/]+)\/runtime\/pools\/[^/]+$/,
  );
  if (triggerPool)
    return `/agent-builder/triggers/${triggerPool[1]}?tab=runtime`;
  const match = pathname.match(
    /^\/agent-builder\/(agents|orchestrators|triggers)\/[^/]+(?:\/.*)?$/,
  );
  return match ? `/agent-builder/${match[1]}` : null;
}
